export default __webpack_public_path__ + "static/media/graphic-21.85a62856.png";